// Version : 0.0.2
// Author : SATHISH
// LastEdit : NANDHAKUMAR
// MODFIED DATE: 5/12/2025
//Last ADD : ADD LOGIN DATA GENERAL COMPANY ID & CHANGED BY USER ID IN EXPORT FUNCTION
import { docodeHexResponse } from '../../_common/common.utils';
import ChangeMeetingActionTypes from './change-meeting-report.type';

const INITIAL_STATE = {
	getChangeMeetingListResponse: null,
	getChangeMeetingListArr: [],
};

const changeMeetingReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET CHANGE MEETING DETAILS START *********************** */
		case ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_SUCCESS:
			return {
				...state,
				getChangeMeetingListResponse: action.payload,
				getChangeMeetingListArr: docodeHexResponse(
					action.payload,
					'GetChangeMeetingReportKey',
				),
			};

		case ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_FAILURE:
			return { ...state, getChangeMeetingListResponse: action.payload };

		case ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_RESPONSE_CHANGED:
			return { ...state, getChangeMeetingListResponse: null };
		/** ***************** GET CHANGE MEETING DETAILS END *********************** */
		default:
			return state;
	}
};

export default changeMeetingReportReducer;
